import moment from 'moment'
import clone from 'clone'
import xtend from 'xtend'

export default {
    getMasterEvent: function () {

        const DefaultDates = {
            startDate: moment().startOf('minute'),
            startTime: moment().startOf('minute'),
            stopDate: moment().add(10, 'm').startOf('minute'),
            stopTime: moment().add(10, 'm').startOf('minute'),
        }

        const MasterEvent = xtend(DefaultDates, {
            // General
            customID: null,
            title: null,
            description: null,
            private: false,
            notes: null,
            streamtext: null,
            categories: [],
            estRuntime: "",

            // Automation
            autoStart: false,
            autoStop: false,
            preroll: 0,
            assignedEncoder: null
        });

        return clone(MasterEvent)
    },

    getDefaultState: function () {

        let event = this.getMasterEvent()
        
        return clone({
            // 'encoder' | 'media'
            mode: null,

            // Event
            event: event,
            edits: {
                startDate: event.startDate,
                startTime: event.startTime,
                stopDate: event.stopDate,
                stopTime: event.stopTime,
                estRuntime: event.estRuntime,
                categories: []
            },
            categories: null,
            categoriesLoaded: false,

            // Wizard
            steps: [],
            active: null,
            invalidModal: false,
            showMultiEventWizard: false,

            // Create-event cycle
            successModal: false,
            createdEvent: null,
            pendingCreate: false
        })
    }
}